module.exports = __webpack_public_path__ + "static/media/ai.a6bcaa58.png";